import { resolveComponent, createBlock, openBlock, createSlots, renderList, withCtx, renderSlot, normalizeProps, guardReactiveProps } from "vue";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const _sfc_main = {};
function _sfc_render(_ctx, _cache) {
  const _component_b_boolean = resolveComponent("b-boolean");
  return openBlock(), createBlock(_component_b_boolean, {
    class: "b-radio",
    type: "radio"
  }, createSlots({ _: 2 }, [
    renderList(_ctx.$slots, (_, slotName) => {
      return {
        name: slotName,
        fn: withCtx((slotProps) => [
          renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps || {})))
        ])
      };
    })
  ]), 1024);
}
const BanzaRadio = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  BanzaRadio as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFSYWRpby52dWUuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jhc2UvQmFuemFSYWRpby52dWUiXSwic291cmNlc0NvbnRlbnQiOlsiPHRlbXBsYXRlPlxuXHQ8Yi1ib29sZWFuXG5cdFx0Y2xhc3M9XCJiLXJhZGlvXCJcblx0XHR0eXBlPVwicmFkaW9cIj5cblx0XHQ8dGVtcGxhdGVcblx0XHRcdHYtZm9yPVwiKF8sIHNsb3ROYW1lKSBpbiAkc2xvdHNcIlxuXHRcdFx0I1tzbG90TmFtZV09XCJzbG90UHJvcHNcIj5cblx0XHRcdDxzbG90XG5cdFx0XHRcdDpuYW1lPVwic2xvdE5hbWVcIlxuXHRcdFx0XHR2LWJpbmQ9XCJzbG90UHJvcHMgfHwge31cIiAvPlxuXHRcdDwvdGVtcGxhdGU+XG5cdDwvYi1ib29sZWFuPlxuPC90ZW1wbGF0ZT5cbiJdLCJuYW1lcyI6WyJfY3JlYXRlQmxvY2siLCJfd2l0aEN0eCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFFRSxtQkFBZSxHQUFBQSxZQUFBLHNCQUFBO0FBQUEsSUFDZixPQUFZO0FBQUE7aUJBRW1CLEVBQUEsR0FBQSxLQUFBO0FBQUE7O1FBRTlCLE1BQUE7QUFBQSxZQUU0QkMsUUFBQSxDQUFBLGNBRFo7QUFBQTs7Ozs7OzsifQ==
